module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_8.2dbd288e.png";